import { Quote } from "lucide-react";

export const TierSpotlight = ({ spotlight, dark = false, testId }) => {
  if (!spotlight?.quote) return null;
  const who = [spotlight.by, spotlight.company].filter(Boolean).join(", ");
  return (
    <figure
      data-testid={testId}
      className={`mt-5 border-l-2 pl-4 py-1 ${dark ? "border-rust text-cream/80" : "border-rust text-espresso/80"}`}
    >
      <div className={`label-font text-[9px] tracking-[0.18em] flex items-center gap-1.5 ${dark ? "text-rust" : "text-rust"}`}>
        <Quote size={10} /> Why we sponsor
      </div>
      <blockquote className="mt-1.5 text-sm italic leading-relaxed">“{spotlight.quote}”</blockquote>
      {who && <figcaption className={`mt-1.5 text-xs not-italic ${dark ? "text-cream/60" : "text-muted-foreground"}`}>— {who}</figcaption>}
    </figure>
  );
};
